import { Component, Inject } from '@angular/core';
import { Store } from '@src/store';
import { enumsActions } from '@src/store/reducers/enumsReducer';
import { securityActions } from '@src/store/reducers/securityReducer';
import { SessionService, DialogManagerService, AuthService } from '@src/services';
import { DbTypeService } from '@src/services/dbTypeService';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { licenseActions } from '@src/store/reducers/licenseReducer';

@Component({
    selector: 'login',
    template: require('./login.component.html'),
    styles: [require('./login.component.scss')]
})
export class LoginComponent {
    public isInvalid = false;
    public isDbMaestro = true;
    public username = '';
    public password = '';
    public rememberMe = true;
    public AuthTypeAndData: any;
    public claims: Object;
    public authHead: string;

    constructor(private store: Store,
        @Inject('$state') private $state: any,
        private sessionService: SessionService,
        private authService: AuthService,
        private translatePipe: TranslatePipe,
        @Inject('dbTypeService') private dbTypeService: DbTypeService,
        private dialogManagerService: DialogManagerService) {
        this.isDbMaestro = !(localStorage.getItem('loginType') === 'domain-type');
    }
    async ngOnInit() {
        try {
            const action = { type: securityActions.AUTHENTICATION_METHOD };
            const response = await this.store.dispatch(action);
            this.AuthTypeAndData = response.data
            localStorage.setItem('AuthType', JSON.stringify(this.AuthTypeAndData.AuthenticationMethod));
            if (this.AuthTypeAndData.AuthenticationMethod == 'oidc') {
                this.authService.setConfiguration(this.AuthTypeAndData)
                this.authService.setManagerSetting()
            }
        } catch (e) {
            console.warn('Failed to fetch AuthenticationMethod, defaulting to standard auth.', e);
            this.AuthTypeAndData = { AuthenticationMethod: 'DBmaestro' };
            localStorage.setItem('AuthType', JSON.stringify('DBmaestro'));
        }
    }

    public navigateToLicenseUpload(event: any) {
        event.preventDefault();
        this.$state.go('app.auth.licenseUpload');
    }

    public async login() {
        const translations = await this.translatePipe.transform(['ERROR_LOGIN', 'ERROR', 'ERROR_LOGIN_SERVER_FAILD']);
        this.isInvalid = false;
        if (this.AuthTypeAndData.AuthenticationMethod == 'oidc') {
            this.authService.startAuthentication();
            this.claims = JSON.stringify(this.authService.getClaims());
            this.authHead = this.authService.getAuthorizationHeaderValue();

        }
        else {
            try {
                const user = {
                    username: this.username,
                    password: this.password,
                    rememberMe: this.rememberMe,
                    authType: this.isDbMaestro ? 'DBmaestro' : 'WINDOWSAUTH'
                };
                const action = { type: securityActions.TOKEN, payload: user, customErrorHandling: true };
                const response = await this.store.dispatch(action);
                if (response.data) {

                    const warningKey = 'warning';
                    this.sessionService.set(warningKey, response.data.warning);

                    this.store.dispatch({
                        type: licenseActions.GET_LICENSE_WARNINGS
                    });

                    response.data.username = this.username;
                    this.sessionService.user = response.data;
                    const enums = this.store.getState().enums;
                    if (enums && enums.DBTypes) {
                        this.dbTypeService.prepareDbTypesImages(enums.DBTypes);
                    } else {
                        const dbTypes = await this.store.dispatch({ type: enumsActions.DB_TYPES });
                        this.dbTypeService.prepareDbTypesImages(dbTypes);
                    }
                    if ((this.$state.params.redirectUri != null || this.$state.params.redirectUri === '')
                        && this.$state.params.redirectUri !== '#/login') {
                        window.location.href = this.$state.params.redirectUri;
                    } else {
                        this.$state.go('app.authorized.projects');
                    }
                }
            } catch (error) {
                switch (error.status) {
                    case 401:
                        this.isInvalid = true;
                        break;
                    case 403:
                        this.dialogManagerService.showErrorDialog({ title: translations['ERROR'], text: error.statusText });
                        break;
                    case 439:
                        const message = translations['ERROR_LOGIN'].replace('%s', error.statusText);
                        this.dialogManagerService.showErrorDialog({ title: translations['ERROR'], text: message });
                        break;
                    case 460:
                        const text = error.data;
                        const messageLicense = text && text !== '' ? text.substring(1, text.length - 1) : '';
                        this.dialogManagerService.showErrorDialog({ title: translations['ERROR'], text: messageLicense });
                        break;
                    default:
                        const data = { title: translations['ERROR'], text: translations['ERROR_LOGIN_SERVER_FAILD'] };
                        this.dialogManagerService.showErrorDialog(data);
                        break;
                }
            }
        }

    }

    public loginTypeChange(isDbMaestro) {
        this.isDbMaestro = isDbMaestro;
        localStorage.setItem('loginType', this.isDbMaestro ? 'dbmaestro-type' : 'domain-type');
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authentication/login/login.component.ts